import { SystemService } from './../service/system.service';
import { NgZone } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, NavigationCancel } from '@angular/router';
import { BLocalStorageService } from '../service/bLocalStorage.service';
import { BTokenService } from '../service/bToken.service';
import { dashboardService } from '../services/dashboard/dashboard.service';
import { BLoginService } from '../service/bLogin.service';
import { PubSubService } from '../service/pubSub.service';
import { Observable } from 'rxjs/Rx';
import { BLogoutService } from '../service/bLogout.service';
import { utilityService } from '../services/utility/utility.service';
// import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
/**
 * Model import Example :
 * import { HERO } from '../models/hero.model.ts';
 */
var layoutpageComponent = (function () {
    function layoutpageComponent(router, activatedRoute, locationStrategy, mulNotificationService, bLoginService, pubsub, logoutService, ngZone, utilityS) {
        var _this = this;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.locationStrategy = locationStrategy;
        this.mulNotificationService = mulNotificationService;
        this.bLoginService = bLoginService;
        this.pubsub = pubsub;
        this.logoutService = logoutService;
        this.ngZone = ngZone;
        this.utilityS = utilityS;
        this.showHomeIcon = false;
        this.bTokenService = new BTokenService();
        this.bLocalStorageService = new BLocalStorageService();
        this.systemS = new SystemService();
        this.router.events.subscribe(function (event) {
            _this.utilityS.applyConditionalCss();
            if ((event instanceof NavigationEnd || event instanceof NavigationCancel) &&
                event.url && (event.url.substr(0, event.url.indexOf('?')) === '/bhive' || event.url === '/bhive' ||
                event.url === '/login' || event.url === '/')) {
                _this.showHomeIcon = false;
            }
            else {
                _this.showHomeIcon = true;
            }
        });
    }
    layoutpageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.startTimerEmitter();
        this.tabListner = this.pubsub.$sub('tabListner', function (eventObject) {
            _this.actionButtons = [];
            if (eventObject && eventObject.length > 0) {
                _this.actionButtons = eventObject;
            }
        });
        if (this.bLocalStorageService.getValue('accessToken')) {
            this.bTokenService.updateSessionStorage();
        }
        if (this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data.dashboard) {
            this.mulNotificationService.dashboardObject = this.activatedRoute.snapshot.data;
        }
    };
    layoutpageComponent.prototype.onPopState = function (event) {
        if (this.systemS.deviceType !== 'browser') {
            if (navigator['app'] && (this.router.url.substr(0, this.router.url.indexOf('?')) === '/bhive' || this.router.url === '/bhive')) {
                navigator['app'].exitApp();
            }
        }
    };
    layoutpageComponent.prototype.navToHome = function () {
        var _this = this;
        this.ngZone.run(function () {
            _this.router.navigate(['/bhive']);
        });
    };
    layoutpageComponent.prototype.logout = function () {
        var _this = this;
        if (this.logoutService.logout()) {
            this.ngZone.run(function () {
                _this.router.navigate(['/login']);
            });
        }
    };
    layoutpageComponent.prototype.broadcastActionEvent = function (event, eventObject) {
        this.pubsub.$pub(event, eventObject);
    };
    layoutpageComponent.prototype.startTimerEmitter = function () {
        var _this = this;
        this.timer = Observable.interval(1000 * 60);
        this.timerSubscription = this.timer.subscribe(function (x) {
            _this.pubsub.$pub('getData');
        });
    };
    layoutpageComponent.prototype.ngOnDestroy = function () {
        this.timerSubscription.unsubscribe();
    };
    return layoutpageComponent;
}());
export { layoutpageComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layoutpageComponent/layoutpage.component.ts.pre-build-optimizer.js